import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  dataMetaSelector,
  deleteVenue,
  dispatchGetUserVenues,
  venueSelectorCreator,
} from "Venues/state";
import { DeleteModal } from "shared/components";
import { copy } from "shared/assets";
import { VENUE_ACTIONS } from "Venues/types";
import { IAPIState, IStatus } from "shared/types";
import { addTemporaryToast } from "shared/components/Toast";
import { useHistory } from "react-router-dom";
import { PATHS } from "App/router";
import { useClearActionMetaOnUnMount } from "Venues/utils";
import { isVenueDomain } from "shared/utils";
import { BAND_PATHS } from "Bands/router";

interface DeleteVenueModalProps {
  venueId: string;
  handleClose: () => void;
  onDelete?: () => void;
}

export const DeleteVenueModal: React.FC<DeleteVenueModalProps> = ({
  venueId,
  handleClose,
  onDelete,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { api: apiMeta } = useSelector(
    dataMetaSelector(VENUE_ACTIONS.deleteVenue)
  );
  useClearActionMetaOnUnMount(VENUE_ACTIONS.deleteVenue);

  const venueIdSelector = useMemo(
    () => venueSelectorCreator(venueId),
    [venueId]
  );
  const venue = useSelector(venueIdSelector);

  const title = useMemo(() => venue?.title || "", [venue]);

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      dispatch(
        addTemporaryToast({
          status: IStatus.success,
          message: copy.deleteVenue.success,
        })
      );
      onDelete && onDelete();
      history.push(isVenueDomain ? PATHS.DASHBOARD : BAND_PATHS.MY_VENUES);
      dispatchGetUserVenues(dispatch, 1);
      handleClose();
    }
  }, [apiMeta, dispatch, handleClose, onDelete, history]);

  const handleDelete = () => {
    if (venueId) {
      dispatch(deleteVenue(venueId));
    }
  };

  return (
    <DeleteModal
      type={copy.venueProperties.venue.title}
      name={title}
      apiMeta={apiMeta}
      handleClose={handleClose}
      handleDelete={handleDelete}
    />
  );
};
